var map = {
	"./CN010101.svg": 7683,
	"./CN010102.svg": 4806,
	"./CN010103.svg": 7350,
	"./CN010104.svg": 5690,
	"./CN010201.svg": 2436,
	"./CN010202.svg": 3747,
	"./CN010203.svg": 1639,
	"./CN010204.svg": 5756,
	"./CN010301.svg": 2494,
	"./CN010401.svg": 3737,
	"./dashboard.svg": 8765,
	"./example.svg": 9362,
	"./eye-open.svg": 7311,
	"./eye.svg": 8090,
	"./form.svg": 5992,
	"./link.svg": 4173,
	"./nested.svg": 9380,
	"./password.svg": 5739,
	"./table.svg": 8288,
	"./tree.svg": 2545,
	"./user.svg": 1324
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2007;